module.exports = __webpack_public_path__ + "static/bg-strips-f13b8524b762ec00971d889fbeab870f.png";